<template>
  <div>
    <md-card :class="selected!=null && address.id == selected.id ? 'selected-card':''">
      <md-card-content style="cursor: pointer;">
        <div v-on:click.stop="$emit('select',address)">
          <span>{{address.firstName}} {{address.lastName}}<br /></span>
          <span>{{address.address1}}<br /></span>
          <span v-if="address.address2 && address.address2.length>0">{{address.address2}}<br /></span>
          <span v-if="address.district && address.district.length>0">{{address.district}}</span>
          <span v-if="address.city && address.city.length > 0">{{address.city}}</span>
          <span v-if="address.state && address.state.length > 0"> {{address.state}}<br/></span>
          <span>{{address.postalCode}} {{address.countryName}}<br /></span>
        </div>
      </md-card-content>
      <md-card-actions>
        <md-button class="md-accent" v-on:click.stop="$emit('update', address)">{{$t('update')}}</md-button>
        <md-button class="md-primary" v-on:click.stop="$emit('select',address)" v-if="selected == null || address.id != selected.id">{{$t('select')}}</md-button>
        <span v-if="selected!=null && address.id == selected.id" class="selected-text" style="text-transform:uppercase">{{$t('selected')}}</span>
      </md-card-actions>
      <div class="selected-icon" v-if="selected!=null && address.id == selected.id">
        <md-icon :md-src="`${imageServer}/new-rma/icon/checkmark.svg`"></md-icon>
      </div>
    </md-card>
  </div>
</template>

<script>
  import { imageServer } from '../config'
  export default {
    name: 'AddressForm',
    props: {
      address: Object,
      selected: Object
    },
    data:()=>({
      imageServer: imageServer
    })
  }
</script>

<style lang="scss" scoped>

  .selected-card {
    background-color: rgb(226, 226, 226)
  }

  .selected-text {
    text-transform:uppercase;
    padding-left: 15px;
    padding-right: 15px;
  }

  .selected-icon {
    position:absolute;
    top:30px; 
    right:15px;
  }
</style>